<style src="./EventMap.scss" lang="scss" scoped></style>
<template>
  <section class="client-map">

    <ul class="grid-card">
      <li
        class="grid-card-item"
        v-for="(item, itemIdx) in list"
        :key="itemIdx"
        :class="{ 'incomplete-event': !item.completeInfo }"
        @click.stop="openEvent(itemIdx, item)">

        <div class="status-col">
          <div class="status-bar" :class="statusColor[item.participate ? 0 : 2]"></div>
        </div>
        <div class="modality-col">
          <div
            class="modality-box">
            <span class="modality-label">{{ item.modality }}</span>
          </div>
        </div>
        <div class="ident-col">
          <span class="short-name">{{ item.client.shortName }}</span>
          <div class="identifications">
            <span class="identification">{{ item.identification }}</span>
            <span class="code" title="Código">{{ item.alternativeCode }}</span>
          </div>
        </div>
        <div class="event-item-info">
          <div class="item-info-container">
            <span class="title">Total de itens</span>
            <span class="item-value">{{ item.info.itemCount }}</span>
          </div>
          <div class="item-info-container">
            <span
              class="title"
              :class="{'value-equal': item.info.itemCount > 0 && (item.info.itemCount === item.info.quoted)}">Itens cotados</span>
            <span
              class="item-value"
              :class="{'value-minus': item.info.itemCount > item.info.quoted, 'value-equal': item.info.itemCount > 0 && (item.info.itemCount === item.info.quoted)}">{{ item.info.quoted }}</span>
          </div>
        </div>
        <div class="item-date">
          <span class="event-date">{{ item.date && item.date.event | FriendlyVerboseDate }}</span>
          <span class="deadline-date">{{ item.date && item.date.deadline | FriendlyVerboseDate }}</span>
        </div>
        <div class="item-commands">
          <!-- <button
            type="button"
            class="btn-ghost"
            @click.stop="edit(itemIdx)">
            <icon-edit />
          </button> -->
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
import { ButtonRemove } from '@/components/primitives'
import { IconEdit } from '@/components/primitives/icons'
import { FriendlyVerboseDate } from '@/components/primitives/helpers/filters'

export default {
  name: 'EventMap',
  components: {
    ButtonRemove,
    IconEdit
  },
  props: {
    list: {
      default: null
    }
  },
  filters: {
    FriendlyVerboseDate
  },
  data () {
    return {
      statusColor: ['open-status', 'closed-status', 'no-participate']
    }
  },
  mounted () {},
  methods: {
    edit (pId) {
      this.$emit('edit', pId)
    },
    openEvent (pIdx, pItem) {
      const breadcrumb = pItem.client.shortName + ' :: ' + pItem.identification
      const eventId = pItem._id
      const eventDetail = pItem
      this.$store.dispatch('Events/OPEN_EVENT', { eventId, eventDetail, breadcrumb, route: this.$router })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/event/components/event-map/EventMap.vue